export enum InvoiceState {
  Approved = 'approved',
  Draft = 'draft',
  Voided = 'voided',
}
